import { format, parseISO, isValid } from 'date-fns';

// Formats a Date as YYYY-MM-DD using the DEVICE's local timezone. Do not use
// d.toISOString().slice(0,10) for "today"/date-range boundaries - toISOString() always
// converts to UTC first, so anyone west of UTC (all of the US) sees the app roll over to
// "tomorrow" hours before midnight actually happens locally (as early as ~7-8pm Eastern).
export function toLocalDateStr(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatCurrency(value) {
  if (value == null) return '$0';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatNumber(value) {
  if (value == null) return '0';
  return new Intl.NumberFormat('en-US').format(value);
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  try {
    const d = typeof dateStr === 'string' ? parseISO(dateStr) : new Date(dateStr);
    return isValid(d) ? format(d, 'MMM d, yyyy') : '—';
  } catch {
    return '—';
  }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '—';
  try {
    const d = typeof dateStr === 'string' ? parseISO(dateStr) : new Date(dateStr);
    return isValid(d) ? format(d, 'MMM d, yyyy h:mm a') : '—';
  } catch {
    return '—';
  }
}

export function formatPercent(value) {
  if (value == null) return '0%';
  return `${(value * 100).toFixed(1)}%`;
}

export function stripHtml(str) {
  if (!str) return '';
  return str.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function truncate(str, len = 40) {
  if (!str) return '';
  const clean = stripHtml(str);
  return clean.length > len ? clean.slice(0, len) + '…' : clean;
}
